import React, { useEffect, useState } from "react";

import Header from "./Header";
import "./Accomodation.css";

import moment from "moment";

import "react-datepicker/dist/react-datepicker.css";
import { Navigate, useNavigate } from "react-router-dom";
import host from "../config";
const RoomBlockingPreview = () => {
  const navigate = useNavigate();

 
  const [blockingReasons, setBlockingReasons] = useState({});
  const [blockingReason, setBlockingReason] = useState("");
  

  localStorage.removeItem("bookingDetailsDataFinal");
  if (
    localStorage.getItem("access_token") == undefined ||
    localStorage.getItem("access_token") === ""
  ) {
    localStorage.removeItem("bookingDetailsData");
  }
  // if (localStorage.getItem("bookingDetailsData") == undefined) {
  //   navigate("/Accommodation", "_self");
  // }
  let bookingDetailsData = localStorage.getItem("selectedRoomData");
  if (bookingDetailsData) {
    bookingDetailsData = JSON.parse(bookingDetailsData);
  } else {
    navigate("/", "_self");
  }
  console.log("bookungD", bookingDetailsData);
  // console.log(bookingDetailsDataFinal,"datafinal")
  const [grandAmountFinal, setGrandAmountFinal] = React.useState(0);
  const [bookingDetailsDataFinal, setBookingDetailsDataFinal] = React.useState(
    []
  );
  const [paymentEncyData, setPaymentEncyData] = React.useState("");

  let sumGrandTotalAmount = 0;
  let bookingDetailsDataFinalTmp = [];
  let seqNo = 1;
  let srNo = 0;
  // let grandTotal = 0;
  let billingRequest = JSON.parse("{}");
  let captchSumValue = 0;

  bookingDetailsData.selectedRooms.map((e, i) => {
    for (let i = 0; i < bookingDetailsData.daysStay; i++) {
      let roomObj = JSON.parse(JSON.stringify(e));
      let tmpDate = new Date(bookingDetailsData.fromDate);
      tmpDate.setDate(tmpDate.getDate() + i);
      roomObj.bookingDate = tmpDate;
      roomObj.rmSeqId = seqNo;
      roomObj.selectedPersons = roomObj.persons;
      roomObj.grandTotalVal = roomObj.amount;
      roomObj.finalGrandTotalVal = roomObj.amount;
      roomObj.purpose = roomObj.purpose;
      bookingDetailsDataFinalTmp.push(roomObj);

      sumGrandTotalAmount = sumGrandTotalAmount + e.amount;
      seqNo++;
    }
  });
  console.log(bookingDetailsDataFinalTmp, "bookingDetailsDataFinalTmp");

  // const grandTotal = filteredBookingDetails.reduce(
  //   (total, item) => total + item.amount,
  //   0
  // );

  useEffect(() => {
    setGrandAmountFinal(sumGrandTotalAmount);
    setBookingDetailsDataFinal(bookingDetailsDataFinalTmp);
  }, []);

  if (
    localStorage.getItem("bookingDetailsDataFinal") !== undefined &&
    localStorage.getItem("bookingDetailsDataFinal") !== null
  ) {
    bookingDetailsDataFinal = JSON.parse(
      localStorage.getItem("bookingDetailsDataFinal")
    );
    setBookingDetailsDataFinal(bookingDetailsDataFinal);
  }
  console.log("final booking", bookingDetailsDataFinal);
  const handleMobileNumberInput = (e) => {
    const maxLength = 10;
    let inputValue = e.target.value;

    // Trim input to the maximum length
    if (inputValue.length > maxLength) {
      inputValue = inputValue.slice(0, maxLength);
      e.target.value = inputValue;
    }
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Group booking details by date range
  const groupedBookingDetails = React.useMemo(() => {
    const groupedData = {};

    bookingDetailsData.selectedRooms.forEach((room) => {
      const key = `${bookingDetailsData.fromDate}-${bookingDetailsData.toDate}`;

      if (!groupedData[key]) {
        groupedData[key] = {
          location_id: room.location_id,
          amount: bookingDetailsData.selectedRooms.amount,
          fromDate: bookingDetailsData.fromDate,
          toDate: bookingDetailsData.toDate,
          totalAmount: 0,
        };
      }

      groupedData[key].totalAmount += room.amount;
    });

    return Object.values(groupedData); // Convert grouped data to an array
  }, [bookingDetailsData]);

  // Calculate the grand total
  const grandTotal = groupedBookingDetails.reduce(
    (total, entry) => total + entry.totalAmount,
    0
  );

  const handleReasonChange = (index, reason) => {
    setBlockingReasons({
      ...blockingReasons,
      [index]: reason,
    });
  };
  const blockNow = (roomId, persons, amount) => {
    if (blockingReason.trim() === "") {
      alert("Please provide a reason for blocking the rooms.");
      return;
    }
    billingRequest.locationId = bookingDetailsData.locationId;

    billingRequest.rooms = bookingDetailsData;
    // Validation: Check if all rooms have a blocking reason
    // for (let i = 0; i < bookingDetailsDataFinal.length; i++) {
    //   if (!blockingReasons[i] || blockingReasons[i].trim() === "") {
    //     alert(`Please provide a reason for blocking room ${i + 1}`);
    //     return;
    //   }
    // }

    billingRequest.roomData = bookingDetailsDataFinal;
    // billingRequest.roomData = bookingDetailsDataFinal.map((room, index) => ({
    //   ...room,
    //   blockReason: blockingReasons[index] || "",
    // }));

    billingRequest.roomData = bookingDetailsDataFinal.map((room) => ({
      ...room,
      blockReason: blockingReason,
    }));
    localStorage.setItem("billingRequest", JSON.stringify(billingRequest));

    fetch(
      host +
        "/update-room-blocking?access_token" +
        localStorage.getItem("access_token"),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
        body: JSON.stringify(billingRequest),
      }
    )
      .then((data) => {
        console.log("Form submitted:", data);
        localStorage.removeItem("bookingDetailsData");
        localStorage.removeItem("bookingDetailsDataFinal");
        alert("The room blocking has been successfully updated.");
        navigate("/", "_self");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <div>
      <Header />
      <div className="container">
        <div className="row">
          {/* <div className="col-lg-2"></div> */}
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  content_back">
            <div className="center_title">Venue Booking Details</div>
            <div className="table-responsive">
              <table className="table table-striped">
                <th>S.No</th>
                <th>Venue Name</th>
                <th>From Date</th>
                <th>To Date</th>
                <th>Amount Per Day</th>
                <th>Total Amount</th>

                <tbody>
                  {bookingDetailsData && (
                    <tr>
                      <td>{bookingDetailsData.locationName}</td>
                      <td>{bookingDetailsData.roomName}</td>
                      {/* <td>{bookingDetailsData.locationId}</td> */}
                      <td>{formatDate(bookingDetailsData.fromDate)}</td>
                      <td>{formatDate(bookingDetailsData.toDate)}</td>
                      <td>{bookingDetailsData.selectedRooms[0].amount}</td>
                      <td>{grandAmountFinal}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="blockk" style={{ marginLeft: "20%" }}>
              <label>
                Block Reason:
                <span style={{ color: "red", marginLeft: "5px" }}>*</span>
              </label>
              <input
                type="text"
                value={blockingReason}
                onChange={(e) => setBlockingReason(e.target.value)}
                placeholder="Enter reason"
                style={{ marginLeft: "10px" }}
              />
            </div>

            <div className="button-container">
              <button
                className="back_button float_left"
                onClick={() => navigate("/", "_self")}
              >
                Back
              </button>
              <button
                className="booking_button float_right"
                onClick={() => blockNow()}
              >
                Block Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default RoomBlockingPreview;
